// @ts-strict-ignore
import Link from 'next/link';
import { useSelector } from 'src/store/store';
import { Disclaimer } from 'src/components/sidebar/disclaimer';
import RelatedPosts from 'src/modules/community/shared/components/sidebar/relatedPosts';
import { Section } from 'src/constants/footfall';
import Card from 'src/components/card';
import i18n from 'src/utils/translate';
import TopicList from 'src/modules/community/shared/components/sidebar/topicList';
import HealthTags from 'src/components/healthTags';
import communitiesWithTopTags from 'src/constants/communitiesWithTopTags';
import SupportingMembersList from 'src/modules/community/shared/components/sidebar/supportingMembersList';
import ContactAdmins from 'src/components/buttons/contactAdmins';
import { communityAdminRoles } from 'src/constants/roles';
import PinnedPosts from 'src/modules/community/shared/components/sidebar/pinnedPosts';
import PopularPosts from 'src/modules/community/shared/components/sidebar/popularPosts';
import Icon from 'src/components/icon';
import { MAX_POSTS_WIDGET } from 'src/constants/widgets';

export default function SinglePostSidebar(): JSX.Element {
  const supportingMembers = useSelector(({ pages }) =>  pages.communityAbout.supportingMembers) || [];
  const { currentCommunity, currentUser } = useSelector(({ context }) => context);
  const { topics } = currentCommunity;
  const {
    pinnedPosts,
    post,
    popularPosts = [],
  } = useSelector(({ pages }) => pages.singlePost);

  if (!post || !currentCommunity) return null;

  const SeeAllLink = () => {
    if (supportingMembers.length <= 3) return null;
    return (
      <Link
        as={`/${currentCommunity.slug}/about#whoweare`}
        href={`/community/communityAbout?communityS;ug=${currentCommunity.slug}#about`}
      >
        {i18n.t('See all')} <Icon icon="open-right" />
      </Link>
    );
  };

  return (
    <div className="post-sidebar">
      <RelatedPosts />

      {supportingMembers.length > 0 && (
        <Card
          seeAllLink={<SeeAllLink />}
          title={i18n.t('Moderation team')}
        >
          <ContactAdmins
            admins={supportingMembers.filter(({ role }) => communityAdminRoles.includes(role))}
            section={Section.POST}
          />
          <SupportingMembersList supportingMembers={supportingMembers.slice(0, 3)} />
        </Card>
      )}

      {/* communitiesWithTopTags is an hardcoded list */}
      {Object.keys(communitiesWithTopTags).includes(currentCommunity.slug) && (
        <Card title={i18n.t('Top community tags')}>
          <HealthTags tags={communitiesWithTopTags[currentCommunity.slug]} />
        </Card>
      )}

      {!currentUser && <PopularPosts posts={popularPosts} />}

      {currentUser && <PinnedPosts posts={pinnedPosts.slice(0, MAX_POSTS_WIDGET)} />}

      {currentUser && <TopicList topics={topics} />}

      <Card>
        <Disclaimer />
      </Card>
    </div>
  );
}
